/**
 * @author Stefano Soresina
 */
import {IListingTypology} from "./ListingTypology";
//@ts-ignore
import {Nullable} from "@customTypes/CustomUtilityTypes";

export interface MultiListingTypology{
    label: string,
    macroTypologyID: number,
    macroTypologyIdList: Nullable<Array<number>>,
    selectedListingTypologies: Array<IListingTypology>,
    selectedListingTypologiesIDList: Array<number>,
    listingTypologyId: number,
    selectedTypologiesIDList: Array<number>,
    group: string,
    groupURL: string,
    url: string,
}
 
export const defaultSelectedListingTypologies = (): IListingTypology => {
    return {
        id: `${window["_macroTypologyDefaultURL"]}`,
        url: `${window["_macroTypologyDefaultURL"]}`,
        attr: {
            "data-hide": []
        },
        label: `${window["_labels"].allTypologies}`,
        labelSelected: `${window["_macroTypologyDefaultURL"]} - ${window["_labels"].allTypologies}`,
        group: `${window["_macroTypologyDefaultLabel"]}`,
        icon: `${window["_macroTypologyDefaultURL"].toUpperCase()}`,
        macroTypologyID: 1,
        macroTypologyIdList: null,
        listingTypologyId: 0,
        listingTypologyID: `${window["_macroTypologyDefaultURL"].toUpperCase()}`,
        typologyIdList: window["_typologyIdListDefault"],
        filterName: "",
        filterValue: ""
    }
}

export function defaultMultiListingTypologyDTO(): MultiListingTypology {
    return {
        label: "",
        macroTypologyID: 1,
        macroTypologyIdList: null,
        selectedListingTypologies: [defaultSelectedListingTypologies()],
        listingTypologyId: 0,
        selectedListingTypologiesIDList: [0],
        selectedTypologiesIDList: window["_typologyIdListDefault"],
        group: `${window["_macroTypologyDefaultLabel"]}`,
        groupURL: `${window["_macroTypologyDefaultURL"]}`,
        url: `${window["_macroTypologyDefaultURL"]}`
    };
}
